import { Lozenge } from "@/domains/common/components/lozenge"
import { BodyLg } from "@/domains/design/components/body-lg"
import { BodySM } from "@/domains/design/components/body-sm"
import { BodyXs } from "@/domains/design/components/body-xs"

export const ClFarmsSubHeader = ({
  displayName,
  tags,
  description,
}: {
  displayName: string
  tags: string[]
  description: string
}) => {
  return (
    <div className="flex w-full flex-col gap-4">
      <div className=" flex flex-row justify-between">
        <BodyLg>{displayName}</BodyLg>
        <div className="flex flex-row gap-1">
          {tags?.map((tag) => {
            switch (tag) {
              case "blue-chip":
                return (
                  <Lozenge color="blue" size="xxs" key={tag}>
                    Blue Chip
                  </Lozenge>
                )
              case "narrow":
                return (
                  <Lozenge color="blue" size="xxs" key={tag}>
                    Narrow
                  </Lozenge>
                )

              default:
                return null
            }
          })}
        </div>
      </div>
      <BodyXs className="text-t300 max-w-xl">{description}</BodyXs>
    </div>
  )
}
